import React, {useState} from 'react'
import logo from '../../assets/images/logo.png'
import coin from '../../assets/images/coin.png'
import vhu from '../../assets/images/vhu.png'
import binh_minh from '../../assets/images/binh_minh.png'
import hea from '../../assets/images/hea.png'
import vt from '../../assets/images/vt.png'
import vh from '../../assets/images/vh.png'
import hpf from '../../assets/images/hpf.png'
import thanh_toan from '../../assets/images/thanh_toan.png'
import { IoIosSearch } from "react-icons/io";
import { MdOutlineArrowDownward } from "react-icons/md";
import { IoChevronDownSharp } from "react-icons/io5";
import { FiMenu } from "react-icons/fi";
import { useNavigate } from 'react-router-dom'
import { TbLogout } from "react-icons/tb";
const CSS_design = {
    li: 'text-[15px] px-[15px] py-[10px] cursor-pointer hover:text-[#3366CC] hover:mb-[-3px] hover:border-b-[3px] hover:border-[#3366CC] font-bold',
    li2: 'text-[#8C8C8C] text-[14px] cursor-pointer flex items-center mr-[2px] hover:text-[#aaa]'
}

export default function Header({isMobile,info}) {
    const [isHovered, setIsHovered] = useState(false)
    const [showMenu, setShowMenu] = useState(false)
    const navigate = useNavigate()


  const handleMouseEnter = () => {
    setIsHovered(true)
  }

  const handleMouseLeave = () => {
    setIsHovered(false)
  }

  const LogOut = () => {
    navigate('https://id.myu.vn');
  };

  return (
    <div className="md:flex md:items-center md:justify-center justify-between p-[15px] md:p-0 w-full min-h-[100px] px-[20px] shadow-md">
        <div className="flex justify-between md:justify-center">
            <a href='https://myu.vn/'><img src={logo} alt='Logo' className='w-[90px] mr-[15px] cursor-pointer' /></a>
            <div className='flex items-center'>
                {/* <IoIosSearch size={'30px'} className='mt-[6px] mx-[15px] cursor-pointer' /> */}
                <FiMenu size={'30px'} className="md:hidden cursor-pointer" onClick={()=>setShowMenu(!showMenu)}/>
            </div>
        </div>
        
        {/* <ul className={`${isMobile?`${showMenu?'':'hidden'}`:'flex items-center'}`}> */}
        <ul className={`${showMenu?'':'hidden'} md:flex items-center`}>
            <a href='https://myu.vn/'><li className={CSS_design.li}>Trang chủ</li></a>
            <a href='https://myu.vn/landing/tuyen-sinh-2024'><li className={CSS_design.li}>Chương trình MyU</li></a>
            <a href='https://myu.vn/shop'><li className={CSS_design.li}>myU Shop</li></a>

            <li className={`${CSS_design.li} flex items-center relative`} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}><span>Sản phẩm dịch vụ</span> <span><IoChevronDownSharp size={'14px'} className='ml-[5px]' /></span>
            <div className={`${isHovered ? 'block' : 'hidden'} absolute top-[40px] w-auto h-auto p-[20px] ${showMenu ? 'left-[0]' : 'md:left-[-50%]'}`}>
                    <div className={`w-full md:w-[500px] h-auto mt-[15px] p-[15px] bg-white shadow-lg rounded-md`}> 
                        <p className='text-black'>Giáo dục</p>
                        <div className='flex border-b-[1px] border-[#ccc] pb-[15px]'>
                            <a href='https://myu.vn/giao-duc/thanh-vien/truong-dai-hoc-van-hien-1'><img src={vhu} alt='logo vhu' className='w-[80px] mx-[10px]' /></a>
                            <a href='https://myu.vn/giao-duc/thanh-vien/cao-dang-binh-minh-sai-gon-4'><img src={binh_minh} alt='logo aurora' className='w-[80px] mx-[10px]' /></a>
                            <a href='https://myu.vn/giao-duc/thanh-vien/cao-dang-au-lac-hue-5'><img src={hea} alt='logo hea' className='w-[80px] mx-[10px]' /></a>
                            <a href='https://myu.vn/giao-duc/thanh-vien/truong-trung-cap-van-tuong-2'><img src={vt} alt='logo vt' className='w-[80px] mx-[10px]' /></a>
                            <a href='https://myu.vn/giao-duc/thanh-vien/truong-trung-cap-y-duoc-van-hanh-3'><img src={vh} alt='logo heh' className='w-[80px] mx-[10px]' /></a>
                        </div>

                        <p className='text-black mt-[10px]'>Thực phẩm</p>
                        <div className='flex border-b-[1px] border-[#ccc] pb-[15px]'>
                            <a href=''><img src={hpf} alt='logo hpf' className='w-[80px] mx-[10px] mt-[10px]' /></a>
                        </div>

                        <p className='text-black mt-[10px]'>Dịch vụ</p>
                        <div className='flex border-b-[1px] border-[#ccc] pb-[15px]'>
                            <a href=''><img src={thanh_toan} alt='logo thanh_toan' className='w-[80px] mx-[10px] mt-[10px]' /></a>
                        </div>
                    </div>
                </div>
            </li>

            <a href='https://myu.vn/tuyen-dung?source=web'><li className={CSS_design.li}>Tuyển dụng</li></a>
            {/* <a href='#'><img src={coin} alt='Logo' className='w-[43px] h-[40px] ml-[15px] cursor-pointer' /></a> */}
            {/* <a href='#'><MdOutlineArrowDownward size={'35px'} color='#fff' className='p-[8px] bg-[#0678BD] mx-[15px] rounded-md cursor-pointer hover:bg-[#397ba4] md:my-[10px]' /></a> */}
        </ul>

        {/* <span className={`${CSS_design.li2} hidden md:inline`}> &nbsp;|&nbsp; </span>
        {
            info ? 
            <div className='md:flex items-center'>
                <div>
                    <p>{info?.full_name}</p>
                    <p className='text-xs text-nowrap'>myU ID:{info?.id}</p>
                </div>
                <span className={`${CSS_design.li2} hidden md:inline`}> &nbsp;|&nbsp; </span>
                <div className='flex gap-1 items-center'>
                    <TbLogout className='text-xl'/>
                    <div onClick={LogOut}>Đăng xuất</div>
                </div>
            </div> : 
            <a href='https://id.myu.vn/account/login?response_type=code&client_id=myu_web&redirect_uri=https://sukien.myu.vn/callback'>
                <li className={CSS_design.li2}>Đăng nhập / Đăng ký</li>
            </a>
        }
         */}
    </div>
  )
}
